import { FormEvent, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { KeyRound, Loader2 } from 'lucide-react';
import { Logo } from '../shell/Logo';
import { resetPassword } from '../api/authApi';
import { ApiError } from '../api/client';

export default function ResetPasswordPage(): JSX.Element {
  const [params] = useSearchParams();
  const token = params.get('token') ?? '';
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [done, setDone] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    if (newPassword !== confirm) {
      setError('두 비밀번호가 일치하지 않습니다.');
      return;
    }
    if (!token) {
      setError('유효한 토큰이 없습니다. 재설정 메일의 링크를 다시 확인해주세요.');
      return;
    }
    setSubmitting(true);
    try {
      await resetPassword(token, newPassword);
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : '비밀번호 재설정에 실패했습니다.');
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <div className="auth-page">
        <div className="auth-form">
          <div className="auth-form__brand">
            <Logo size={20} showText={false} />
            <span className="auth-form__brand-name">Alpha Omega Quant</span>
          </div>
          <h1>비밀번호가 변경되었습니다</h1>
          <p>새 비밀번호로 로그인해주세요.</p>
          <Link to="/login">로그인으로</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-page">
      <form className="auth-form" onSubmit={onSubmit}>
        <div className="auth-form__brand">
          <Logo size={20} showText={false} />
          <span className="auth-form__brand-name">Alpha Omega Quant</span>
        </div>
        <h1>새 비밀번호 설정</h1>
        <label>
          <span>새 비밀번호 (8자 이상)</span>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
        </label>
        <label>
          <span>새 비밀번호 확인</span>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
            minLength={8}
            autoComplete="new-password"
          />
        </label>
        {error && <div className="auth-error" role="alert">{error}</div>}
        <button type="submit" disabled={submitting}>
          {submitting ? (
            <Loader2 size={16} strokeWidth={1.75} className="pca-spin" />
          ) : (
            <KeyRound size={16} strokeWidth={1.75} />
          )}
          {submitting ? '변경 중...' : '비밀번호 변경'}
        </button>
        <div className="auth-links">
          <Link to="/login">로그인으로</Link>
        </div>
      </form>
    </div>
  );
}
